import {VideoListNavigationPrevButtonDefaultBox, VideoListNavigationNextButtonDefaultBox, VideoListLeftCutDefaultBox, VideoListRightCutDefaultBox} from "./video-navigation.default.box";

export const VideoListNavigationPrevButtonBox = VideoListNavigationPrevButtonDefaultBox;
export const VideoListNavigationNextButtonBox = VideoListNavigationNextButtonDefaultBox;

export const VideoListLeftCutBox = VideoListLeftCutDefaultBox;
export const VideoListRightCutBox = VideoListRightCutDefaultBox;
